import MainLayout from "Layouts/Main";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  getAdditionalInsightsDetail,
  getCategoryAndSubCategory,
  getPreviousAnswerDetails,
  getUserAnswer,
} from "../../../../Redux/Slices/Accessor/accessorSlice";
import "./styles.scss";
import ApprovalSubModule from "Components/ApprovalSubModule";
import { useLocation, useNavigate } from "react-router-dom";
import ApprovalAnswer from "Components/ApprovalAnswer";
import ApprovalSparePartsLogo from "Components/ApprovalSparePartsLogo";
import { addApproveReject, addApproverFeedback } from "../../../../Redux/Slices/Approver/approverSlice";
import Button from "Components/Button";
import Modal from "Components/Modal";
import InputBox from "Components/InputBox";
import { notifySuccess } from "Services/Utils/toastNotification";
import ReactQuill from 'react-quill-new';
import "quill/dist/quill.snow.css";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import ApproveSparePartsDetails from "Components/ApprovalSparePartsDetails";
import { getUserFeedbackModule } from "../../../../Redux/Slices/User/userSlice";
import scrollToTop from "Services/Utils/scrolltoTop";

const ApprovalViewDetail = () => {
  const [activeCategoryId, setActiveCategoryId] = useState("");
  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
  const [currentSubCategoryIndex, setCurrentSubCategoryIndex] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [sparePartsLogData, setSparePartsLogData] = useState([]);
  const [rejectionReason, setRejectionReason] = useState("");
  const [errorReasonMessage, setErrorReasonMessage] = useState("");
  const [rejectModal, setRejectModal] = useState(false);
  const [feedbacks, setFeedbacks] = useState({});
  const [approverMediaFiles, setApproverMediaFiles] = useState({});
  const [researchData, setResearchData] = useState();
  const [recommendationData, setRecommendationData] = useState();

  const formMethods = useForm({
    defaultValues: {
      categories: [],
    },
  });

  const { setValue, watch } = formMethods;
  const categories = watch("categories");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const company_name = location?.state?.company_name;
  const assessment_id = location?.state?.assessment_id;
  const categoryId = location?.state?.category_id;
  const subCategoryId = location?.state?.sub_category_id;
  const assessor_id = location?.state?.assessor_id;
  const [isLoading, setIsloading] = useState(false);

  const buttonTitleStyle = {
    fontSize: "16px",
    fontWeight: "600",
  };

  const noteLabel = {
    color: "#2E2E2E",
    fontSize: "16px",
    fontWeight: "600",
  };

  const buttonStyle = {
    height: "44px",
    outline: "none",
    border: "1px solid #1F2155",
  };

  const previousButtonStyle = {
    height: "44px",
    border: "1.5px solid #00000033",
    background: "#FDFDFD",
  };

  const previousTitle = {
    fontSize: "16px",
    fontWeight: "400",
    color: "#000000",
  };

  const approveButton = {
    background: "#1F2155",
    border: "1px solid  #1F2155",
    height: "44px",
    outline: "none",
  };
  const rejectButton = {
    background: "transparent",
    border: "1px solid #F76363",
    height: "44px",
    outline: "none",
  };

  const rejectTitle = {
    fontSize: "16px",
    fontWeight: "600",
    color: "#F04343",
  };

  const approveTitle = {
    fontSize: "16px",
    fontWeight: "600",
    color: "white",
  };

  useEffect(() => {
    getAllModule();
  }, []);

  const getAllModule = () => {
    dispatch(
      getCategoryAndSubCategory({
        callBack: getAllData,
      })
    );
  };

  const getAllData = (data) => {
    // Process the existing data as before
    data = data?.map((item) => {
      return {
        ...item,
        sub_categories: [
          ...item?.sub_categories?.map((element, index) => {
            return {
              ...element,
              questions: element?.questions?.map((y) => {
                return {
                  ...y,
                  observation: "",
                  evidence: [],
                  insights: "",
                  recommendation: [""],
                  userAnswer: [],
                  finalScore: "",
                  options: y?.options?.map((z) => {
                    return {
                      ...z,
                      isChecked: false,
                    };
                  }),
                };
              }),
              isCompleted: true,
            };
          }),
          {
            subCategory_id: item?.sub_categories?.length + 1,
            subCategory_name: "Additional insights",
            additionalInsightsData: [],
            questions: [],
            isCompleted: true,
          },
          {
            subCategory_id: item?.sub_categories?.length + 2,
            subCategory_name: "Feedback",
            questions: [],
            feedbackData: [],
            isFeedback: true,
            isCompleted: true,
          },
        ],
      };
    });
    const newCategory = {
      category_id: data.length + 1,
      category_name: "KG PRODUCT OFFERINGS",
      sub_categories: [
        {
          subCategory_id: 1,
          subCategory_name: "KG Product Offerings",
          additionalInsightsData: [],
          questions: [],
          isCompleted: true,
        },
      ],
    };
    const spareDetailsCategory = {
      category_id: data.length + 2,
      category_name: "PRODUCT MAPPING",
      // category_name: "KG SPARE PARTS",
      sub_categories: [
        {
          subCategory_id: 1,
          subCategory_name: "Product Mapping",
          // subCategory_name: "KG Spare Parts",
          additionalInsightsData: [],
          questions: [],
          isCompleted: true,
        },
      ],
    };

    data.push(newCategory);
    data.push(spareDetailsCategory);

    // Update the state with the modified data
    setValue("categories", data);
    const updatedData = [...data];

    if (updatedData.length && categoryId && subCategoryId) {
      const catIndex = updatedData.findIndex(cat => cat.category_id === categoryId);
      const subCatIndex = updatedData[catIndex]?.sub_categories?.findIndex(sub => sub.subCategory_id === subCategoryId);

      if (catIndex !== -1 && subCatIndex !== -1) {
        setActiveCategoryId(categoryId);
        setCurrentCategoryIndex(catIndex);
        setCurrentSubCategoryIndex(subCatIndex);
      }
    } else if (data.length > 0 && !categoryId && !subCategoryId) {
      setActiveCategoryId(data[0].category_id);
    }
  };

  const handleTab = (category_id, index) => {
    setActiveCategoryId(category_id);
    setCurrentCategoryIndex(index);
    setCurrentSubCategoryIndex(0);
    scrollToTop(".subModuleWrap")
  };

  const filteredSubCategories = categories?.find(
    (cat) => cat?.category_id === activeCategoryId
  )?.sub_categories;

  const category_id = categories[currentCategoryIndex]?.category_id;
  const sub_category_id =
    categories[currentCategoryIndex]?.sub_categories[currentSubCategoryIndex]
      ?.subCategory_id;
  const question_id =
    categories[currentCategoryIndex]?.sub_categories[currentSubCategoryIndex]
      ?.questions[currentQuestionIndex]?.question_id;

  const isLastSubCategory =
    currentSubCategoryIndex ===
    categories[currentCategoryIndex]?.sub_categories?.length - 1;

  const isAdditionalInsights = currentSubCategoryIndex === categories[currentCategoryIndex]?.sub_categories?.length - 2;

  const isSeconLastCategory = currentCategoryIndex === categories.length - 2;

  const isLastCategory = currentCategoryIndex === categories?.length - 1;

  useEffect(() => {
    if (categories.length > 0 && !isLastSubCategory && !isLastCategory && !isAdditionalInsights) {
      getUserAnswerData(category_id, sub_category_id);
    }
  }, [categories.length, category_id, sub_category_id]);

  const getUserAnswerData = (category_id, sub_category_id) => {
    dispatch(
      getUserAnswer({
        assessment_id: assessment_id,
        category_id: category_id,
        sub_category_id: sub_category_id,
        company_name: company_name,
        callBack: getUserAnswerDetails,
      })
    );
  };

  const getUserAnswerDetails = (data) => {
    const updatedData = [...categories];
    updatedData[currentCategoryIndex].sub_categories[
      currentSubCategoryIndex
    ].questions[currentQuestionIndex].userAnswer = data?.data?.answers;

    setValue("categories", updatedData);
  };

  // Additional Insights API
  useEffect(() => {
    if (isAdditionalInsights && !isLastCategory) {
      getAdditionalInsights();
    } else if (isLastSubCategory && !isLastCategory) {
      getIndividualFeedback();
    }
  }, [currentSubCategoryIndex, currentCategoryIndex, categories.length]);

  const getIndividualFeedback = () => {
    dispatch(
      getUserFeedbackModule({
        assessment_id: assessment_id,
        category_id: category_id,
        role: "assessor",
        callBack: (data) => handleGetFeedback(data, category_id),
      })
    );
  }

  const handleGetFeedback = (data, categoryId, subCategoryId) => {
    const response = data?.feedback;
    const feedbackDataFromAPI = response?.map((item) => {
      return {
        comments: item?.comment,
        rating: item?.rating,
      };
    });
    const updatedData = [...categories];
    updatedData[currentCategoryIndex].sub_categories[
      currentSubCategoryIndex
    ].feedbackData = feedbackDataFromAPI;
    setValue("categories", updatedData);
  };

  const getAdditionalInsights = () => {
    dispatch(
      getAdditionalInsightsDetail({
        assessment_id: assessment_id,
        category_id: category_id,
        company_name: company_name,
        callBack: getAdditionalInsightsData,
      })
    );
  };

  const getAdditionalInsightsData = (data) => {
    const response = data?.data;
    const additionalInsightsData = response?.map((item) => {
      return {
        mediaFiles: item?.media_files,
        comments: item?.comments,
        userName: item?.user_name,
      };
    });

    const updatedData = [...categories];
    updatedData[currentCategoryIndex].sub_categories[
      currentSubCategoryIndex
    ].additionalInsightsData = additionalInsightsData;
    setValue("categories", updatedData);
  };

  useEffect(() => {
    if (categories.length && !isLastSubCategory && !isLastCategory && !isAdditionalInsights) {
      getPreviousAnswer();
    }
  }, [
    categories.length,
    currentCategoryIndex,
    currentSubCategoryIndex,
    currentQuestionIndex,
  ]);

  // Previous Data API
  const getPreviousAnswer = () => {
    dispatch(
      getPreviousAnswerDetails({
        assessment_id: assessment_id,
        category_id: category_id,
        sub_category_id: sub_category_id,
        question_id: question_id,
        callBack: getPreviousAnswerData,
      })
    );
  };

  const getPreviousAnswerData = (data) => {
    const { research_data, recommendation_data, sparePartLogData } = data?.data;
    setResearchData(research_data)
    setRecommendationData(recommendation_data)
    setSparePartsLogData(sparePartLogData);

    const research = research_data[0];

    const updatedData = [...categories];
    const activeQuestionData =
      updatedData[currentCategoryIndex]?.sub_categories[currentSubCategoryIndex]
        ?.questions[currentQuestionIndex];

    activeQuestionData.observation = research?.notes || "";
    activeQuestionData.insights = research?.insights || "";
    activeQuestionData.finalScore = research?.final_score || "";
    activeQuestionData.approver_feedback = research?.approver_feedback || "";

    if (
      research?.approver_feedback &&
      (!feedbacks[activeQuestionData.question_id] || feedbacks[activeQuestionData.question_id] !== research.approver_feedback)
    ) {
      setFeedbacks((prev) => ({
        ...prev,
        [activeQuestionData.question_id]: research.approver_feedback,
      }));
    }
    if (Array.isArray(research?.approver_feedback_upload) && research.approver_feedback_upload.length > 0) {
    const approverFiles = research.approver_feedback_upload.map(url => ({
      url: url,
      name: decodeURIComponent(url.split("---").pop() || ""),
    }));
    
    setApproverMediaFiles((prev) => ({
      ...prev,
      [activeQuestionData.question_id]: approverFiles,
    }));
  }
    if (research?.final_score) {
      updatedData[currentCategoryIndex].sub_categories[
        currentSubCategoryIndex
      ].isCompleted = true;
    }

    // Handle evidence as array of objects with text & image_url
    if (Array.isArray(research?.upload)) {
      activeQuestionData.evidence = research.upload.map(item => ({
        url: item.image_url || "",
        name: decodeURIComponent(item.image_url?.split("---").pop() || ""),
        text: item.text || "",
      }));
    } else {
      activeQuestionData.evidence = [];
    }

    // Handle recommendation_data with message & image_url
    if (recommendation_data?.length > 0) {
      activeQuestionData.recommendation = recommendation_data.map(item => ({
        recText: item.message || "",
        url: item.image_url || "",
      }));
    } else {
      activeQuestionData.recommendation = [{ recText: "", url: "" }];
    }

    setValue("categories", updatedData);
  };


  const handlePrevious = () => {
    const isFirstSubCategory = currentSubCategoryIndex === 0;
    const isFirstCategory = currentCategoryIndex === 0;

    if (isFirstSubCategory && !isFirstCategory) {
      // Move to the previous category
      setCurrentCategoryIndex((prev) => prev - 1);
      setActiveCategoryId(categories[currentCategoryIndex - 1]?.category_id);

      // Get the last subcategory of the previous category
      const lastSubCategoryIndex =
        categories[currentCategoryIndex - 1]?.sub_categories.length - 1;
      setCurrentSubCategoryIndex(lastSubCategoryIndex); // Move to the last subcategory of the previous category
    } else if (!isFirstSubCategory) {
      // Move to the previous subcategory within the same category
      setCurrentSubCategoryIndex((prev) => prev - 1);
    }
    const container = document.querySelector(".main-layout-body-content");
    if (container) {
      container.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const nextQuestion = () => {
    if (isLastSubCategory) {
      if (!isLastCategory) {
        setCurrentCategoryIndex(currentCategoryIndex + 1);
        setActiveCategoryId(categories[currentCategoryIndex + 1]?.category_id);
        setCurrentSubCategoryIndex(0);
      }
    } else {
      setCurrentSubCategoryIndex(currentSubCategoryIndex + 1);
    }
  }

  const handleNext = () => {
    // Send feedback for the current question before moving
     // Send feedback for the current question before moving
  if (question_id && feedbacks[question_id]) {
    const mediaUrls = approverMediaFiles[question_id]?.map(file => file.url) || [];
      dispatch(
        addApproverFeedback({
          assessment_id,
          category_id,
          sub_category_id,
          question_id,
          body: { approver_feedback: feedbacks[question_id], approver_feedback_upload: mediaUrls },
          callBack: nextQuestion
          // () => {
          //   // Optionally clear feedback for this question
          //   setFeedbacks((prev) => ({ ...prev, [question_id]: "" }));
          // },
        })
      );

    } else {
      // Move to next if no feedback
      if (isLastSubCategory) {
        if (!isLastCategory) {
          setCurrentCategoryIndex(currentCategoryIndex + 1);
          setActiveCategoryId(categories[currentCategoryIndex + 1]?.category_id);
          setCurrentSubCategoryIndex(0);
          scrollToTop('.subModuleWrap')
        }
      } else {
        setCurrentSubCategoryIndex(currentSubCategoryIndex + 1);
      }
    }
    scrollToTop()
  }

  const onSubmitAndPreview = () => {
    // if (isLoading) {
    //   return;
    // }
    // setIsloading(true);
    // const body = {
    //   approval_status: 2,
    //   assessor_id: assessor_id,
    // };
    // dispatch(
    //   addApproveReject({
    //     assessment_id: assessment_id,
    //     body: body,
    //     callBack: onApproveSuccess,
    //   })
    // );
    navigate(`/approval/view-detail/preview/${assessment_id}`, {
      state: {
        assessment_id: assessment_id,
        assessor_id: assessor_id,
      },
    });
  };


  return (
    <MainLayout>
      <div className="questionChapterWrap">
        {categories?.map((item, categoryIndex) => (
          <div
            key={categoryIndex}
            className={`questionChapterLabel ${activeCategoryId === item?.category_id ? "active" : ""
              }`}
            onClick={() => handleTab(item?.category_id, categoryIndex)}
          >
            {item?.category_name}
          </div>
        ))}
      </div>
      <div className="subModuleQuestionWrap">
        <div className="subModuleWrap">
          <label className="subModuleLabel mb-4">Sub-Modules</label>
          <div>
            {filteredSubCategories?.map((item, subCategoryIndex) => {
              return (
                <div key={subCategoryIndex}>
                  <ApprovalSubModule
                    onclick={() => {
                      setCurrentSubCategoryIndex(subCategoryIndex)
                      scrollToTop()
                    }}
                    subModule={item}
                    index={subCategoryIndex}
                    totalSteps={filteredSubCategories?.length}
                    currentSubCategoryIndex={currentSubCategoryIndex}
                    displayNumber={item?.subCategory_id}
                  />
                </div>
              );
            })}
          </div>
        </div>
        <div className="questionModuleWrap">
          {isLastCategory ? (
            //  sparePartsLogData.map((data, index) => (
            //   <ApprovalSparePartsLogo key={index} data={data} />
            // ))
            // <div>Last Spare parts category</div>
            <ApproveSparePartsDetails assessment_id={assessment_id} />
          ) :
            isSeconLastCategory ? (
              sparePartsLogData.map((data, index) => (
                <ApprovalSparePartsLogo key={index} data={data} />
              ))
            ) :

              (
                <ApprovalAnswer
                  categories={categories}
                  categoryIndex={currentCategoryIndex}
                  setCategoryIndex={setCurrentCategoryIndex}
                  subCategoryIndex={currentSubCategoryIndex}
                  setSubCategoryIndex={setCurrentSubCategoryIndex}
                  feedback={feedbacks[question_id] || ""}
                  setFeedback={(val) =>
                    setFeedbacks((prev) => ({
                      ...prev,
                      [question_id]: val,
                    }))
                  }
                  questionId={question_id}
                  approverMediaFiles={approverMediaFiles}  // Add this
                  setApproverMediaFiles={setApproverMediaFiles}  // Add this
                  dispatch={dispatch}  // Add this
                  researchData={researchData}
                  recommendationData={recommendationData}
                />
              )}
        </div>
      </div>

      <div className="d-flex justify-content-end my-3 me-3">
        <div className="me-3">
          {!(currentCategoryIndex === 0 && currentSubCategoryIndex === 0) && (
            !isLastCategory && (
              <Button
                title={"Previous"}
                buttonStyle={previousButtonStyle}
                titleStyle={previousTitle}
                onClick={handlePrevious}
                disabled={isLoading}
              />
            ))}
        </div>

        <Button
          title={isLastCategory ? "Submit & Preview" : "Next"}
          titleStyle={isLastCategory ? approveTitle : buttonTitleStyle}
          buttonStyle={isLastCategory ? approveButton : buttonStyle}
          forForm={true}
          disabled={isLoading}
          onClick={isLastCategory ? onSubmitAndPreview : handleNext}
        />
      </div>

      <Modal
        open={rejectModal}
        closeModal={() => {
          setRejectModal(false);
        }}
      >
        <div className="closeModalContainer_Contact">
          <InputBox
            type="textarea"
            label={"Reason for Rework"}
            inputStyle={{
              height: "200px",
            }}
            labelStyle={noteLabel}
            value={rejectionReason}
            onChange={(e) => {
              setRejectionReason(e?.target?.value);
              if (errorReasonMessage) {
                setErrorReasonMessage("");
              }
            }}
          />
          {errorReasonMessage && (
            <p
              style={{
                color: "red",
                fontSize: "14px",
                marginBottom: "10px",
                fontFamily: "inter",
              }}
            >
              {errorReasonMessage}
            </p>
          )}

          <div>
            <Button
              onClick={() => {
                if (rejectionReason?.trim() === "") {
                  setErrorReasonMessage(
                    "Please enter a reason before submitting."
                  );
                  return;
                } else {
                  const body = {
                    approval_status: 3,
                    assessor_id: assessor_id,
                    rejection_reason: rejectionReason,
                  };
                  dispatch(
                    addApproveReject({
                      assessment_id: assessment_id,
                      body: body,
                      callBack: navigate(-1),
                    })
                  );
                  setRejectModal(false);
                  setRejectionReason("");
                  setErrorReasonMessage("");
                }
              }}
              buttonStyle={{
                height: "44px",
                width: "150px",
                float: "right",
                marginTop: "15px",
              }}
              titleStyle={{ fontSize: "16px", }}
              title="Submit"
            />
          </div>
        </div>
      </Modal>
    </MainLayout>
  );
};

export default ApprovalViewDetail;
